import auroraColorPalette from '../colors';

const pallete = {
  primary: auroraColorPalette.primary,
  secondary: auroraColorPalette.secondary,
  action: {
    hover: 'rgba(80,80,80, 0.05)',
    hoverOpacity: 0.05,
  },
};

export default pallete;
